import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/analytics'
import 'firebase/compat/storage'
import 'firebase/compat/auth'

// Support both default and named exports to avoid undefined imports
import firebaseConfigDefault, { firebaseConfig as firebaseConfigNamed } from '../config'

const firebaseConfig = firebaseConfigNamed || firebaseConfigDefault

// Fail early with a clear message (instead of Firebase's app/no-options)
if (!firebaseConfig || !firebaseConfig.apiKey || !firebaseConfig.projectId) {
  // eslint-disable-next-line no-console
  console.error(
    '[firebase] Missing config. Create a .env file (see .env.example) with VUE_APP_FIREBASE_* values and restart the dev server.'
  )
  throw new Error(
    'Firebase config is missing. Create a .env file (see .env.example) with VUE_APP_FIREBASE_* values and restart the dev server.'
  )
}

// Initialize Firebase (Firebase v9+ compatible via `compat` imports)
firebase.initializeApp(firebaseConfig)

// Analytics is optional (can fail in some envs / missing measurementId)
try {
  firebase.analytics()
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('[firebase] analytics init failed:', e?.message || e)
}

const db = firebase.firestore()

// Optional: offline persistence can reduce billed reads for repeat visits.
// If it fails (e.g. multiple tabs, unsupported browser), we just continue.
try {
  db.enablePersistence({ synchronizeTabs: true })
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('[firebase] persistence not enabled:', e?.message || e)
}

const storage = firebase.storage()
const storageRef = storage.ref()
const auth = firebase.auth()

export { firebase, db, storage, storageRef, auth }
